import React from "react";
import assign from "lodash/assign";
import get from "lodash/get";
import set from "lodash/set";
import { TextField, RaisedButton, Checkbox } from "material-ui";
import { Link } from "react-router";

import config from "../config";
import Label from "./partials/label.jsx";
import SelectField from "./partials/select-field.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import UserActions from "../actions/UserActions";
import UserStore from "../stores/UserStore";

const PASSWORD_PLACEHOLDER = "•••••••••";

class Account extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      dirty: false,
      fetched: false,
      values: {
        email_snapshot_frequency: "never", // default
        email_threshold_alerts: false
      }
    };

    this.onChange = this.onChange.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
    this.save = this.save.bind(this);
  }

  static getStores() {
    return [UserStore];
  }

  static getPropsFromStores() {
    return UserStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {
      actions: {
        marginTop: 30
      },
      connections: {
        marginTop: 30
      },
      connection: {
        marginTop: 10
      }
    };
  }

  onChange(id, e, checked) {
    this.onChangeValue(
      id,
      typeof checked !== "undefined" ? !checked : e.target.value
    );
  }

  onChangeValue(id, value) {
    this.state.dirty = true;
    set(this.state.values, id, value);
    this.setState(this.state);
  }

  save() {
    var values = assign({}, this.state.values);
    UserActions.edit(values);
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    var user = newProps.data;

    if (user) {
      user.password = "";
    }

    if (!this.state.isFetchingUser && !this.state.fetched) {
      UserActions.fetch();
      this.setState({ isFetchingUser: true });
    } else if (user) {
      this.setState({ isFetchingUser: false });
    }

    this.setState({ user, dirty: false, fetched: true, values: user || {} });
  }

  render() {
    var styles = this.getStyles();

    if (!this.state.user) {
      return <WorkingIndicator fullPage={true} />;
    }

    var { user, apiKey } = this.state;

    return (
      <div>
        <h1>Account</h1>
        <div>
          <div>
            <TextField
              value={get(this.state, "values.name", "") || ""}
              floatingLabelText="Name"
              onChange={e => this.onChangeValue("name", e.target.value)}
            />
          </div>
          <div>
            <TextField
              value={get(this.state, "values.email", "") || ""}
              floatingLabelText="Email address"
              onChange={e => this.onChangeValue("email", e.target.value)}
            />
          </div>
          <div>
            {this.state.editingPassword ? (
              <TextField
                value={get(this.state, "values.password", "") || ""}
                floatingLabelText="Password"
                floatingLabelFixed={true}
                hintText={PASSWORD_PLACEHOLDER}
                type="password"
                autoComplete="new-password"
                onChange={e => this.onChangeValue("password", e.target.value)}
              />
            ) : (
              <div style={{ marginBottom: 15 }}>
                <Label>Password</Label>
                <RaisedButton
                  label={"Change password"}
                  primary={false}
                  onTouchTap={() => this.setState({ editingPassword: true })}
                />
              </div>
            )}
          </div>
          <div style={{ marginTop: 15 }}>
            <Label>Organization</Label>
            <div style={{ fontSize: 16 }}>
              {get(this.state, "user.owner.organization", "")}
            </div>
            {UserStore.hasPermission("manage_organization") ? (
              <div>
                <Link to="/organization">Manage organization</Link>
              </div>
            ) : null}
          </div>
        </div>
        <div style={{ marginTop: 15 }}>
          <Label>Email preferences</Label>
          {UserStore.getUserType() !== "content_creator" &&
          UserStore.hasPermission("view_analytics") ? (
            <div>
              <Checkbox
                label="Send event bucket activity snapshot"
                checked={this.state.values.email_snapshot_frequency !== "never"}
                onCheck={(e, checked) => {
                  this.onChangeValue(
                    "email_snapshot_frequency",
                    checked ? "week" : "never"
                  );
                }}
              />
              {this.state.values.email_snapshot_frequency !== "never" ? (
                <SelectField
                  style={{ width: 100, marginLeft: 40, marginBottom: 10 }}
                  options={[
                    { value: "day", label: "Daily" },
                    { value: "week", label: "Weekly" }
                  ]}
                  value={this.state.values.email_snapshot_frequency}
                  clearable={false}
                  onChange={o =>
                    this.onChangeValue("email_snapshot_frequency", o.value)
                  }
                />
              ) : null}
              <Checkbox
                label="Send threshold alerts (when ticket sales exceed 80% capacity)"
                checked={this.state.values.email_threshold_alerts}
                onCheck={(e, checked) => {
                  this.onChangeValue("email_threshold_alerts", checked);
                }}
              />
            </div>
          ) : (
            <div>You have no available emails to configure.</div>
          )}
        </div>
        <div style={styles.actions}>
          <RaisedButton
            label={this.state.dirty ? "Save changes" : "No changes to save"}
            primary={true}
            disabled={!this.state.dirty}
            onClick={this.save}
          />
        </div>
      </div>
    );
  }
}

export default connectToStores(Account);



// WEBPACK FOOTER //
// ./src/app/components/account.jsx